<template>
  <div>

    <!-- page banner -->
    <page-banner
      :title="!showError ? $t('banner.thank_you') : $t('confirmation.no_booking')"
      :subTitle="!showError ? ( amend ? $t('banner.update_complete') : $t('banner.payment_complete') ) : $t('confirmation.confirmation')"
      :promoBox="false"
      :breadcrumb="false"
    />

    <div class="main-area container style05">
      <div class="main-holder">
        <div class="row">
          <div class="col-lg-8 col-12">
            <div class="confirmation-content">
              <div class="heading-area" v-if="booking && booking.details.bookings">
                <h2>{{ amend ? $t('confirmation.thank_you_updated') : $t('confirmation.thank_you') }} <span v-if="!amend">{{ siteName }}</span> </h2>

                <span v-if="booking.details && booking.details.transaction" class="number">
                  {{ $t('confirmation.order_id') }}: {{ booking.details.transaction.transaction_id }}
                </span>

                <!-- Fresh -->
                <img :src="`//d1f0tbk1v3e25u.cloudfront.net/pc/lmmrk31c/?e=${booking.details.customer.email}&r=${booking.details.transaction.transaction_id}`" id="__tms_pc" height="1" width="1" />

                <!-- liveramp iframe -->
                <iframe v-if="email" name="_rlcdn" width=0 height=0 frameborder=0 :src="`https://ejp.rlcdn.com/473286.html?s=${email}`"></iframe>
              </div>
              <div class="booking-info" v-if="booking && booking.details.bookings">
                <div v-for="(category, key) in booking.details.bookings" :key="key">
                  <div v-if="category.length > 0">
                    <div class="wrap">
                      <strong v-if="prettyCategory(key)" class="title">{{ prettyCategory(key) }} {{ $t('confirmation.booking_ref') }}:</strong>
                    </div>
                    <div class="wrap booking-ref" v-for="(product, childKey) in category" :key="childKey">
                      <span class="ref-no">{{ product.booking.booking_ref }}</span>
                      <small v-if="key === 'airportparking'">{{ $t('confirmation.vehicle')}}: {{ product.booking.vehicle_reg }}</small>

                      <!-- partnerize -->
                      <partnerize-pixel v-if="partnerizeShow && booking && (key === 'airportparking' || key === 'airporthotel')" :booking="booking" :product="product.product" />
                    </div>
                  </div>
                </div>
                <div class="wrap">
                  <strong class="title">{{ $t('confirmation.total_cost') }}</strong>
                  <span class="price">{{ currency }}{{ amount }}</span>
                  <span  v-if="credits > 0"><small>{{ $t('confirmation.credits') }}: {{ currency }}{{ credits }}</small></span>
                </div>
                <ul class="btn-list list-unstyled">
                  <li>
                    <router-link target="_blank" :to="{ path: 'confirmation-view', query: { id }}" class="btn-primary">{{ $t('confirmation.view_booking') }}</router-link>
                  </li>
                  <li>
                    <router-link target="_blank" :to="{ path: 'confirmation-view', query: { id, print: true }}" class="btn-secondary">{{ $t('confirmation.print') }}</router-link>
                  </li>
                </ul>
                <span class="note">* {{ $t('confirmation.please_print') }}</span>

                <a v-if="amend" href="/account" class="btn btn-primary my-3">{{ $t('confirmation.account') }}</a>
              </div>
              <div class="script-block p-5" v-if="!showError">
                <div class="webloyalty" id='wf3946b9cea0ab5ddeb0ce54d5f0341c0'></div>
                <div v-if="rentalCarsId !== '' && booking && booking.details">
                  <div v-for="(category, key) in booking.details.bookings" :key="key">
                    <div v-if="category.length > 0 && key === 'airportparking'">
                      <div v-for="(product, childKey) in category" :key="childKey">
                        <iframe
                          :src="`https://secure.rentalcars.com/WidgetSearch.do?affiliateCode=${rentalCarsId}&preflang=en&results=3&pickupIATACode=&pickupHour=12&pickupMinute=30&returnHour=10&returnMinute=30&pickupDate=${getDate(product.booking.departure_date_time, 'D')}&pickupMonth=${getDate(product.booking.departure_date_time, 'M')}&pickupYear=${getDate(product.booking.departure_date_time, 'Y')}&returnDate=${getDate(product.booking.return_date_time, 'D')}&returnMonth=${getDate(product.booking.return_date_time, 'M')}&returnYear=${getDate(product.booking.return_date_time, 'Y')}&prefcurrency=GBP`"
                          width="100%"
                          height="475"
                          scrolling="no"
                          frameborder="0">
                        </iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-12" v-if="!showError">
            <div class="confirmation-sidebar">
              <h2>{{ $t('confirmation.happens_next') }}</h2>
              <p>{{ $t('confirmation.happens_next_point_1') }}</p>
              <p>{{ $t('confirmation.happens_next_point_2a') }}</p>
              <p class="mb-2"><strong>{{ $t('confirmation.happens_next_point_2b') }}:</strong></p>
              <p>{{ $t('confirmation.happens_next_point_3') }}</p>
              <p>{{ $t('confirmation.happens_next_point_4a') }} <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a> {{ $t('confirmation.happens_next_point_4b') }}</p>
              <p>{{ $t('confirmation.happens_next_point_5') }}</p>
              <div class="social-wrap" v-if="facebook">
                <a :href="facebook"><img :src="`${cdn}/images/social-icon.png`" alt="facebook"></a>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-12" v-if="showError">
            <div class="confirmation-content">
              <h4 v-if="showError" class="text-danger text-center mt-3">{{ $t('confirmation.no_booking') }}.</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { call, sync, get } from "vuex-pathify";
import { PageBanner } from "@/components";
import mixins from "@/mixins";
import moment from "moment";
import PartnerizePixel from "../components/booking-flow/payment/partnerize-pixel";

export default {
  name: 'confirmation',
  mixins: [mixins.format, mixins.globals, mixins.pageview],
  components: {PartnerizePixel, PageBanner },
  data() {
    return {
      id: null,
      showError: false,
      email: null
    }
  },
  computed: {
    booking: sync("payment/confirmation"),
    quote: get("quote"),
    airport: get("results/airport@airport_name"),
    partnerizeUrl() { return process.env.VUE_APP_PARTNERIZE_URL; },
    partnerizeShow() { return this.partnerizeUrl !== null && this.partnerizeUrl.length > 0 },
    amount() { return this.booking.details.transaction.amount_paid.toFixed(2); },
    credits() {
      let transactions = this.booking.details.transactions.filter(item => item.money_type === 'credits' && item.action_type === 'out');
      return transactions.length > 0 ? transactions[0].amount_paid : 0;
    },
    amend: sync("payment/amend"),
  },
  methods: {
    toggleProgress: call("payment/toggleProgress"),
    getBooking: call("payment/confirmation"),
    mxmSet: call("customer/mxmConfirmation"),
    getDate(product, format) {
      return moment(product).format(format)
    }
  },
  mounted() {

    this.toggleProgress(false)

    document.addEventListener("DOMContentLoaded", () => {
      this.mxmSet();
      this.sendPageView();
    });
    // override onbeforeload function when confirmed
    window.onbeforeunload = function () {}
  },
  created() {
    this.booking = null;
    this.id = this.$route.query.id;

    this.$loadScript("https://maxemail.emailcenteruk.com/scripts/basket.js")

    if(this.id) {
      this.getBooking(this.id).then(() => {

        if(!this.booking) return this.showError = true;

        const products = [];
        const fbProducts = [];
        const irProducts = [];
        let commissionWithAddons = this.booking.details.transaction.commission || 0;
        window.dataLayer = window.dataLayer || [];

        // eslint-disable-next-line
        Object.keys(this.booking.details.bookings).map((index, _) => {

          this.booking.details.bookings[index].map((product) => {

            // calculate GA transaction value
            if(index === 'addon' && product.product.addon_name.indexOf('Access') === -1) commissionWithAddons = commissionWithAddons + product.booking.sale_price;
            if(index === 'addon' && product.product.addon_name.indexOf('Access') > -1) product.booking.sale_price = 0.00;

            products.push({
              'sku': `${index}g${product.booking.product_id}`,
              'name': product.product.park_name || product.product.addon_name || product.product.hotel_name || product.product.lounge_name,
              'category': index,
              'price': product.booking.commission || parseFloat(product.booking.sale_price).toFixed(2),
              'quantity': 1
            });

            let prefix = {
              'airportparking': 'ap',
              'airporthotel': 'ah',
              'airportlounge': 'al',
              'addon': 'ad'
            }

            fbProducts.push({
              "id":`${prefix[index]}-${product.booking.product_id}`,
              "quantity": 1,
              "item_price": (product.booking.commission / 1.20).toFixed(2)
            })

            irProducts.push({
              subTotal: (product.booking.sale_price / 1.20).toFixed(2),
              category: product.product.cg_name || 'DEFAULT',
              sku: `${index}-${product.booking.product_id || product.booking.addon_id}`,
              quantity: 1,
              name: product.product.park_name || product.product.addon_name || product.product.hotel_name || product.product.lounge_name,
            })
          })
        })

        // impact radius conversion
        if(irProducts.length > 0) {

          const combinedbookings = [
            ...this.booking.details.bookings.airportparking || [],
            ...this.booking.details.bookings.airportlounge || [],
            ...this.booking.details.bookings.airporthotel || [],
            ...this.booking.details.bookings.addons || []
          ]

          // liveramp email set
          this.email = combinedbookings.length > 0 ? combinedbookings[0].booking.customer_email_address : ''

          const impactTracking = {
            orderId: this.booking.details.transaction.transaction_id,
            customerId: combinedbookings[0].booking.customer_id,
            customerEmail: combinedbookings[0].booking.customer_email_address,
            customerStatus: '',
            orderPromoCode: combinedbookings[0].booking.promo_code,
            date1: moment(combinedbookings[0].booking.departure_date_time).format('YYYY-MM-DD'),
            date2: moment(combinedbookings[0].booking.return_date_time).format('YYYY-MM-DD'),
            text1: combinedbookings[0].product.airport_id,
            text2: combinedbookings[0].booking.agent_id,
            note: `${combinedbookings[0].booking.days}|${combinedbookings[0].booking.agent_commission.toFixed(2)}`,
            orderRebate: combinedbookings[0].booking.discount.toFixed(2),
            money1: this.booking.details.transaction.commission.toFixed(2),
            currencyCode: 'GBP',
            items: irProducts
          }

          // impact radius conversion
          if(typeof window.ire !== 'undefined') {
            window.ire('trackConversion', 6763, impactTracking, { verifySiteDefinitionMatch: true });
          }
        }

        // facebook conversion
        window.fb_contents = fbProducts;
        window.fb_transaction = this.booking.details.transaction.transaction_id;
        window.currency_code = 'GBP';

        // bing
        window.uetq = window.uetq || [];
        window.uetq.push({ 'gv': parseFloat(commissionWithAddons).toFixed(2) });

        // ga adwords - not sure if needed, could be old way
        // eslint-disable-next-line
        dataLayer.push({
          'google_conversion_value': parseFloat(commissionWithAddons).toFixed(2),
          'google_conversion_order_id': this.booking.details.transaction.transaction_id
        })
        // eslint-disable-next-line
        dataLayer.push({
          'event': 'pageview',
        })

        // ga conversion -  this triggers most of the tracking so have this after other variables are set
        // eslint-disable-next-line
        dataLayer.push({
          'event': 'purchase',
          'transactionId': this.booking.details.transaction.transaction_id,
          'transactionAffiliation': 'www.skyparksecure.com',
          'transactionTotal': parseFloat(commissionWithAddons).toFixed(2),
          'transactionTax': 0,
          'transactionShipping': 0,
          'transactionProducts': products,
          'transactionCurrency': 'GBP',
          'confirmationAirport': this.airport || '',
          'confirmationDateA': this.quote.dateA || '',
          'confirmationDateB': this.quote.dateB || '',
        });
      })
    } else {
      window.location.href = 'https://www.skyparksecure.com'
    }
  }
};
</script>

